<template>
  <div class="raceIntroduction">
    <childLogo></childLogo>
    <div class="navbar-dark">
      <div class="container" style="min-height: 520px;">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">校园报名信息</span>
          </div>
        </div>
        <div style="font-size: 21px;margin: 15px;color: #5e5e5e;text-align: center">{{siteName}}</div>
        <CompusUp></CompusUp>
      </div>
    </div>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
import CompusUp from "@/components/CompusUpModule.vue";
import {siteMess} from "@/api/system/index"
export default {
  name:"CampusRegistration",
  components: {
    ChildLogo: ChildLogo,
    CompusUp: CompusUp
  },
  data() {
    return {
      siteName:"",
    };
  },
  created() {
    siteMess(this.siteURL,this.siteId).then(res=>{
      this.siteName = res.data.name;
    })
    /* 判定当前用户是否已经参赛，如果没有参赛，跳转路由到参赛页面 */
    // 根据当前用户id
    // let userId = this.$store.state.user.userId;
    // // 拼接请求url
    // var api =
    //   this.baseURL +
    //   `/actuator/participant/list?userId=${userId}&siteId=${this.siteId}`;
    // this.axios.get(api, {}).then(res => {
    //   // res.data.rows[0].status == 1
    //   if (res.data.rows.length == 1 && res.data.rows[0].id) {
    //     this.$router.push({
    //       path: "/myHome",
    //       query: { id: 1 }
    //     });
    //   }
    // });
  }
};
</script>

<style scoped>
.expertName {
  display: inline-block;
  text-align: left;
  width: 50%;
  color: #0654ef;
  font-size: 36px;
  padding-left: 20px;
}

.introduction {
  text-align: left;
  padding: 20px;
  text-indent: 2em;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0654ef; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0654ef;
}

.firstLevel {
  text-align: left;
  font-weight: bold;
}

.raceIntroduction .el-form-item__content > div {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/CampusRegistration.vue